import { Success, Failure, PromiseResult } from 'libs/apis/errors/Result';
import { AppError } from 'libs/apis/errors/AppError';
import type { GetFavoriteProductsV2Response } from 'libs/apis/generated/models/GetFavoriteProductsV2Response';
import type { ResultOkResponse } from 'libs/apis/generated/models/ResultOkResponse';
import type { PostFavoriteProductForm } from 'libs/apis/generated/models/PostFavoriteProductForm';
import { getFavoriteProductsV2, getWishlistProducts, postFavoriteProduct, deleteFavoriteProduct } from 'libs/apis';

export type FetchFavoriteProductsParams = {
  favoriteListId: number;
  page?: number;
};

export type FetchWishlistProductsParams = {
  token: string;
  page?: number;
};

type FavoriteProductMutationParams = {
  productId: number;
  isPublished: boolean;
};

export const fetchFavoriteProducts = (
  params: FetchFavoriteProductsParams
): PromiseResult<GetFavoriteProductsV2Response, AppError> =>
  (async () => {
    try {
      const response = await getFavoriteProductsV2(params);
      return new Success(response);
    } catch (error) {
      return new Failure(new AppError((error as Error).message));
    }
  })();

export const fetchWishlistProducts = (
  params: FetchWishlistProductsParams
): PromiseResult<GetFavoriteProductsV2Response, AppError> =>
  (async () => {
    try {
      const response = await getWishlistProducts(params);
      return new Success(response);
    } catch (error) {
      return new Failure(new AppError((error as Error).message));
    }
  })();

export const addFavoriteProduct = (params: FavoriteProductMutationParams): PromiseResult<ResultOkResponse, AppError> =>
  (async () => {
    try {
      const requestBody: PostFavoriteProductForm = {
        productId: params.productId,
        isPublished: params.isPublished,
      };
      const response = await postFavoriteProduct(requestBody);
      return new Success(response);
    } catch (error) {
      return new Failure(new AppError((error as Error).message));
    }
  })();

export const removeFavoriteProduct = (
  params: FavoriteProductMutationParams
): PromiseResult<ResultOkResponse, AppError> =>
  (async () => {
    try {
      const response = await deleteFavoriteProduct({
        productId: params.productId,
        isPublished: params.isPublished,
      });
      return new Success(response);
    } catch (error) {
      return new Failure(new AppError((error as Error).message));
    }
  })();
